<div class="cds-flex cds-items-center cds-gap-2">
  <div cbToggle="#underwritingTerms" toggleOnText="" toggleOffText="" [showIcons]="true" [readonly]="true">
    <input
      type="checkbox"
      [required]="false"
      [(ngModel)]="hasUnderwritingTerms"
      data-testid="policy-cover-underwritting-option" />
  </div>
  <span class="label">Underwriting Terms</span>
  @if (hasUnderwritingTerms) {
    <button
      cbButton
      label="(Show)"
      variant="ghost"
      colorTheme="blue"
      (click)="handleModal()"
      class="!cds-px-0"
      data-testid="policy-cover-show-underwritting-button"></button>
  }
</div>

<div>
  <cb-modal
    [open]="open"
    (closeEvent)="handleModal()"
    title="Underwriting terms"
    [closeOnEscape]="false"
    customContent="true"
    [hideCloseIcon]="false"
    [hideDefaultFooter]="true"
    data-testid="policy-underwritting-modal">
    <div class="container cds-flex-col cds-gap-4">
      <!-- Show Percentage Loading Section only if loadingPercentage is not null -->
      @if (coverage().loadingPercentage != null) {
        <p>
          <strong>Loading Type:</strong>
          Percentage
        </p>
        <p data-testid="underwritting-percentage-value">
          <strong>Loading Value:</strong>
          {{ percentile(coverage().loadingPercentage!) }}%
        </p>
      }

      <!-- Show Per Mille Loading Section only if loadingPermillie is not null -->
      @if (coverage().loadingPermillie != null) {
        <p>
          <strong>Loading Type:</strong>
          Per Mille
        </p>
        <p data-testid="underwritting-permille-value">
          <strong>Loading Value:</strong>
          ${{ percentile(coverage().loadingPermillie!) }}
        </p>
      }
      @if (coverage().loadingPartialTerm != null) {
        <p data-testid="underwritting-term-value">
          <strong>Term:</strong>
          {{ coverage().loadingPartialTerm }} years
        </p>
      }

      @if (coverage().exclusions && coverage().exclusions!.length > 0) {
        <p class="cds-mb-1 cds-font-bold">Exclusions:</p>
        @for (exclusion of coverage().exclusions; track exclusion) {
          <p data-testid="underwritting-exclusion-value">
            <strong>{{ exclusion.wording }}</strong>
            - {{ exclusion.fullText }}
          </p>
        }
      }
    </div>
  </cb-modal>
</div>
